const gtmService = {
  init: () => {
    gtmService.loadGtm()
  },
  loadGtm: () => {
    const runtimeConfig = useRuntimeConfig()
    const gtmID = runtimeConfig.public.GTM_ID
    if (!document.querySelector(`script[data-gtm-id='${gtmID}']`)) {
      const gtmScript = document.createElement('script')
      gtmScript.setAttribute('data-gtm-id', gtmID)
      gtmScript.innerHTML = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmID}');
    `
      document.head.appendChild(gtmScript)
    }
  },
}

export default gtmService
